const dashCamisas = [
  {
    id: "dash-0",
    pais: "italia",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 26/27 - Uniforme 4",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Milan-26-27-04/uni0.jpg",
      "/images/dashboard/Milan-26-27-04/uni1.jpg",
      "/images/dashboard/Milan-26-27-04/uni2.jpg",
      "/images/dashboard/Milan-26-27-04/uni3.jpg",
      "/images/dashboard/Milan-26-27-04/uni4.jpg",
    ],
  },
  {
    id: "dash-1",
    pais: "inglaterra",
    liga: "premier-league",
    time: "arsenal",
    nome: "Arsenal 25/26 - Uniforme 3",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Arsenal-25-26-03/ars0.jpg",
      "/images/dashboard/Arsenal-25-26-03/ars1.jpg",
      "/images/dashboard/Arsenal-25-26-03/ars2.jpg",
      "/images/dashboard/Arsenal-25-26-03/ars3.jpg",
      "/images/dashboard/Arsenal-25-26-03/ars4.jpg",
    ],
  },
  {
    id: "dash-2",
    pais: "italia",
    liga: "serie-a",
    time: "atalanta",
    nome: "Atalanta 25/26 - Uniforme 2",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Atalanta-25-26-02/ata0.jpg",
      "/images/dashboard/Atalanta-25-26-02/ata1.jpg",
      "/images/dashboard/Atalanta-25-26-02/ata2.jpg",
      "/images/dashboard/Atalanta-25-26-02/ata3.jpg",
      "/images/dashboard/Atalanta-25-26-02/ata4.jpg",
    ],
  },
  {
    id: "dash-3",
    pais: "holanda",
    liga: "holanda",
    time: "ajax",
    nome: "Ajax 25/26 - Uniforme 3",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Ajax-25-26-03/uni0.jpg",
      "/images/dashboard/Ajax-25-26-03/uni1.jpg",
      "/images/dashboard/Ajax-25-26-03/uni2.jpg",
      "/images/dashboard/Ajax-25-26-03/uni3.jpg",
      "/images/dashboard/Ajax-25-26-03/uni4.jpg",
    ],
  },
  {
    id: "dash-4",
    pais: "inglaterra",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme 3",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Liverpool-25-26-03/uni0.jpg",
      "/images/dashboard/Liverpool-25-26-03/uni1.jpg",
      "/images/dashboard/Liverpool-25-26-03/uni2.jpg",
      "/images/dashboard/Liverpool-25-26-03/uni3.jpg",
      "/images/dashboard/Liverpool-25-26-03/uni4.jpg",
    ],
  },
  {
    id: "dash-5",
    pais: "italia",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 25/26 - Uniforme 1",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Milan-25-26-01/uni0.jpg",
      "/images/dashboard/Milan-25-26-01/uni1.jpg",
      "/images/dashboard/Milan-25-26-01/uni2.jpg",
      "/images/dashboard/Milan-25-26-01/uni3.jpg",
      "/images/dashboard/Milan-25-26-01/uni4.jpg",
    ],
  },
  {
    id: "dash-6",
    pais: "escocia",
    liga: "escocia",
    time: "rangers",
    nome: "Rangers 25/26 - Uniforme 1",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Rangers-25-26-01/uni0.jpg",
      "/images/dashboard/Rangers-25-26-01/uni1.jpg",
      "/images/dashboard/Rangers-25-26-01/uni2.jpg",
      "/images/dashboard/Rangers-25-26-01/uni3.jpg",
      "/images/dashboard/Rangers-25-26-01/uni4.jpg",
    ],
  },
  {
    id: "dash-7",
    pais: "alemanha",
    liga: "bundesliga",
    time: "bayern",
    nome: "Bayern de Munique 25/26 - Uniforme 2",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Bayern-25-26-03/bay0.jpg",
      "/images/dashboard/Bayern-25-26-03/bay1.jpg",
      "/images/dashboard/Bayern-25-26-03/bay2.jpg",
      "/images/dashboard/Bayern-25-26-03/bay3.jpg",
      "/images/dashboard/Bayern-25-26-03/bay4.jpg",
    ],
  },
  {
    id: "dash-8",
    pais: "turquia",
    liga: "Super Lig",
    time: "Fenerbahce",
    nome: "Fenerbahce 25/26 - Uniforme 2",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Fenerbahce-25-26-02/fen0.jpg",
      "/images/dashboard/Fenerbahce-25-26-02/fen1.jpg",
      "/images/dashboard/Fenerbahce-25-26-02/fen2.jpg",
      "/images/dashboard/Fenerbahce-25-26-02/fen3.jpg",
      "/images/dashboard/Fenerbahce-25-26-02/fen4.jpg",
    ],
  },
  {
    id: "dash-9",
    pais: "estados-unidos",
    liga: "MLS",
    time: "inter-miam",
    nome: "Inter Miami 25/26",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Inter-Miami-25-26/int0.png",
      "/images/dashboard/Inter-Miami-25-26/int1.png",
      "/images/dashboard/Inter-Miami-25-26/int2.png",
      "/images/dashboard/Inter-Miami-25-26/int3.png",
      "/images/dashboard/Inter-Miami-25-26/int4.png",
    ],
  },
  {
    id: "dash-10",
    pais: "italia",
    liga: "serie-a",
    time: "juventus",
    nome: "Juventus 25/26 Uniforme 03",
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Juventus-25-26-03/juv0.png",
      "/images/dashboard/Juventus-25-26-03/juv1.png",
      "/images/dashboard/Juventus-25-26-03/juv2.png",
      "/images/dashboard/Juventus-25-26-03/juv3.png",
      "/images/dashboard/Juventus-25-26-03/juv4.png",
    ],
  },
  {
    id: "dash-11",
    pais: "brasil",
    liga: "internacional",
    time: "brasil",
    nome: "Brasil 91/92 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/91-92-01-rt/uni0.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni1.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni2.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni3.jpg",
      "/images/selecaobrasileira/91-92-01-rt/uni4.jpg",
    ],
  },
  {
    id: "dash-12",
    pais: "brasil",
    liga: "internacional",
    time: "brasil",
    nome: "Brasil 94/95 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/94-95-01-rt/uni0.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni1.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni2.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni3.jpg",
      "/images/selecaobrasileira/94-95-01-rt/uni4.jpg",
    ],
  },
  {
    id: "dash-13",
    pais: "brasil",
    liga: "internacional",
    time: "brasil",
    nome: "Brasil 94/95 - Uniforme 2 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/94-95-02-rt/uni0.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni1.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni2.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni3.jpg",
      "/images/selecaobrasileira/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: "dash-14",
    pais: "brasil",
    liga: "internacional",
    time: "brasil",
    nome: "Brasil 02/03 - Uniforme 2 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/selecaobrasileira/02-03-01-rt/uni0.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni1.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni2.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni3.jpg",
      "/images/selecaobrasileira/02-03-01-rt/uni4.jpg",
    ],
  },

  {
    id: "dash-15",
    pais: "argentina",
    liga: "internacional",
    time: "argentina",
    nome: "Argentina 06/07 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Argentina-06-07-01/uni0.jpg",
      "/images/dashboard/Argentina-06-07-01/uni1.jpg",
      "/images/dashboard/Argentina-06-07-01/uni2.jpg",
      "/images/dashboard/Argentina-06-07-01/uni3.jpg",
      "/images/dashboard/Argentina-06-07-01/uni4.jpg",
    ],
  },
  {
    id: "dash-16",
    pais: "alemanha",
    liga: "internacional",
    time: "argentina",
    nome: "Argentina 98/99/01 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Alemanha-98-99-01/uni0.jpg",
      "/images/dashboard/Alemanha-98-99-01/uni1.jpg",
      "/images/dashboard/Alemanha-98-99-01/uni2.jpg",
      "/images/dashboard/Alemanha-98-99-01/uni3.jpg",
      "/images/dashboard/Alemanha-98-99-01/uni4.jpg",
    ],
  },
  {
    id: "dash-17",
    pais: "italia",
    liga: "serie-a",
    time: "roma",
    nome: "Roma 99/00 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Roma-99-00-01/uni0.jpg",
      "/images/dashboard/Roma-99-00-01/uni1.jpg",
      "/images/dashboard/Roma-99-00-01/uni2.jpg",
      "/images/dashboard/Roma-99-00-01/uni3.jpg",
      "/images/dashboard/Roma-99-00-01/uni4.jpg",
    ],
  },
  {
    id: "dash-18",
    pais: "espanha",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 92/93 - Uniforme 2 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Barcelona-92-93-02/uni0.jpg",
      "/images/dashboard/Barcelona-92-93-02/uni1.jpg",
      "/images/dashboard/Barcelona-92-93-02/uni2.jpg",
      "/images/dashboard/Barcelona-92-93-02/uni3.jpg",
      "/images/dashboard/Barcelona-92-93-02/uni4.jpg",
    ],
  },
  {
    id: "dash-19",
    pais: "espanha",
    liga: "la-liga",
    time: "barcelona",
    nome: "Barcelona 98/99 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/Barcelona-98-99-01/uni0.jpg",
      "/images/dashboard/Barcelona-98-99-01/uni1.jpg",
      "/images/dashboard/Barcelona-98-99-01/uni2.jpg",
      "/images/dashboard/Barcelona-98-99-01/uni3.jpg",
      "/images/dashboard/Barcelona-98-99-01/uni4.jpg",
    ],
  },
  {
    id: "dash-20",
    pais: "inglaterra",
    liga: "premier-league",
    time: "mu",
    nome: "Manchester United 07/08 - Uniforme 1 Retrô",
    tipo: "masculino",
    categoria: "retro",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/MU-07-08-01/uni0.jpg",
      "/images/dashboard/MU-07-08-01/uni1.jpg",
      "/images/dashboard/MU-07-08-01/uni2.jpg",
      "/images/dashboard/MU-07-08-01/uni3.jpg",
      "/images/dashboard/MU-07-08-01/uni4.jpg",
    ],
  },
  {
    id: "dash-21",
    pais: "america-do-sul",
    liga: "internacional",
    time: "argentina",
    nome: "Argentina 26 - Uniforme 1",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/argentina/uni0.jpg",
      "/images/dashboard/argentina/uni1.jpg",
      "/images/dashboard/argentina/uni2.jpg",
      "/images/dashboard/argentina/uni3.jpg",
      "/images/dashboard/argentina/uni4.jpg",
    ],
  },
  {
    id: "dash-22",
    pais: "internacional",
    liga: "internacional",
    time: "alemanha",
    nome: "Alemanha 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/alemanha/uni0.jpg",
      "/images/dashboard/alemanha/uni1.jpg",
      "/images/dashboard/alemanha/uni2.jpg",
      "/images/dashboard/alemanha/uni3.jpg",
      "/images/dashboard/alemanha/uni4.jpg",
    ],
  },
  {
    id: "dash-23",
    pais: "internacional",
    liga: "internacional",
    time: "arabia",
    nome: "Arabia Saudita 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/arabia/uni0.jpg",
      "/images/dashboard/arabia/uni1.jpg",
      "/images/dashboard/arabia/uni2.jpg",
      "/images/dashboard/arabia/uni3.jpg",
      "/images/dashboard/arabia/uni4.jpg",
    ],
  },
  {
    id: "dash-24",
    pais: "internacional",
    liga: "internacional",
    time: "belgica",
    nome: "Bélgica 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/belgica/uni0.jpg",
      "/images/dashboard/belgica/uni1.jpg",
      "/images/dashboard/belgica/uni2.jpg",
      "/images/dashboard/belgica/uni3.jpg",
      "/images/dashboard/belgica/uni4.jpg",
    ],
  },
  {
    id: "dash-25",
    pais: "internacional",
    liga: "internacional",
    time: "colombia",
    nome: "Colombia 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/colombia/uni0.jpg",
      "/images/dashboard/colombia/uni1.jpg",
      "/images/dashboard/colombia/uni2.jpg",
      "/images/dashboard/colombia/uni3.jpg",
      "/images/dashboard/colombia/uni4.jpg",
    ],
  },
  {
    id: "dash-26",
    pais: "internacional",
    liga: "internacional",
    time: "espanha",
    nome: "Espanha 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/espanha/uni0.jpg",
      "/images/dashboard/espanha/uni1.jpg",
      "/images/dashboard/espanha/uni2.jpg",
      "/images/dashboard/espanha/uni3.jpg",
      "/images/dashboard/espanha/uni4.jpg",
    ],
  },
  {
    id: "dash-27",
    pais: "internacional",
    liga: "internacional",
    time: "grecia",
    nome: "Grecia 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/grecia/uni0.jpg",
      "/images/dashboard/grecia/uni1.jpg",
      "/images/dashboard/grecia/uni2.jpg",
      "/images/dashboard/grecia/uni3.jpg",
      "/images/dashboard/grecia/uni4.jpg",
    ],
  },
  {
    id: "dash-28",
    pais: "internacional",
    liga: "internacional",
    time: "italia",
    nome: "Italia 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/italia/uni0.jpg",
      "/images/dashboard/italia/uni1.jpg",
      "/images/dashboard/italia/uni2.jpg",
      "/images/dashboard/italia/uni3.jpg",
      "/images/dashboard/italia/uni4.jpg",
    ],
  },
  {
    id: "dash-29",
    pais: "internacional",
    liga: "internacional",
    time: "japao",
    nome: "Japão 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/japao/uni0.jpg",
      "/images/dashboard/japao/uni1.jpg",
      "/images/dashboard/japao/uni2.jpg",
      "/images/dashboard/japao/uni3.jpg",
      "/images/dashboard/japao/uni4.jpg",
    ],
  },
  {
    id: "dash-30",
    pais: "internacional",
    liga: "internacional",
    time: "mexico",
    nome: "México 26 - Uniforme 2",
    tipo: "masculino",
    categoria: "novidade-copa",
    edicaoEspecial: false,
    imagens: [
      "/images/dashboard/mexico/uni0.jpg",
      "/images/dashboard/mexico/uni1.jpg",
      "/images/dashboard/mexico/uni2.jpg",
      "/images/dashboard/mexico/uni3.jpg",
      "/images/dashboard/mexico/uni4.jpg",
    ],
  },
];

export default dashCamisas;
